import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@/ui/Button/Button';
import styled from 'styled-components';
import { Customer } from '@/types/Customer';
import { useState } from 'react';
import { Modal } from '@/ui/Modal/Modal';
import { useCreateCustomer } from '@/features/_data/useCustomerData';
import { TOASTTYPE, useToast } from '@/ui/Toast/Toast';
import { Input } from '@/ui/Input/Input';

const StyledModalButtons = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: right;
  & button {
    margin-left: 1rem;
  }
`;

const StyledInputWrapper = styled.div`
  margin-bottom: 0.7rem;
`;

type Props = {
  readonly customerData: Customer[];
  readonly setCustomerData: (customerData: Customer[]) => void;
  readonly setShouldShowAddCustomerModal: (state: boolean) => void;
};

export const AddCustomerModal = ({
  customerData,
  setCustomerData,
  setShouldShowAddCustomerModal,
}: Props) => {
  const [newCustomerName, setNewCustomerName] = useState('');
  const { createCustomer } = useCreateCustomer();
  const toast = useToast();
  const intl = useIntl();

  return (
    <Modal
      onClose={() => {
        setNewCustomerName('');
        setShouldShowAddCustomerModal(false);
      }}
      title={<FormattedMessage defaultMessage="Add Customer" id="MDPHxV" />}
    >
      <div>
        <StyledInputWrapper>
          <FormattedMessage defaultMessage="Customer Name" id="Gr1SAu" />:
        </StyledInputWrapper>
        <Input
          value={newCustomerName}
          onChange={setNewCustomerName}
          testId="new-customer-name"
        />
      </div>
      <StyledModalButtons>
        <Button
          onClick={async () => {
            if (newCustomerName === '') {
              toast({
                title: intl.formatMessage({
                  defaultMessage: 'Please enter a valid customer name.',
                  id: 'CUMh/t',
                }),
                mode: TOASTTYPE.Danger,
              });
              return;
            }
            const newCustomer = await createCustomer({
              name: newCustomerName,
            });
            const updatedCustomerData = [...customerData];
            updatedCustomerData.push(newCustomer);
            setCustomerData(updatedCustomerData);
            setNewCustomerName('');
            setShouldShowAddCustomerModal(false);
          }}
          testId="create-customer"
        >
          <FormattedMessage defaultMessage="Create" id="VzzYJk" />
        </Button>
      </StyledModalButtons>
    </Modal>
  );
};
